import api from './api';

/**
 * Obtener configuración de notificaciones
 */
export const obtenerConfiguracion = async (proyectoId, email) => {
  try {
    const response = await api.get(`/notificaciones/proyecto/${proyectoId}?email=${email}`);
    return response.data.configuracion;
  } catch (error) {
    console.error('Error al obtener configuración:', error);
    throw error;
  }
};

/**
 * Guardar configuración de notificaciones
 */
export const guardarConfiguracion = async (config) => {
  try {
    const response = await api.post('/notificaciones/guardar', config);
    return response.data;
  } catch (error) {
    console.error('Error al guardar configuración:', error);
    throw error;
  }
};

/**
 * Limpiar historial de notificaciones
 */
export const limpiarHistorial = async (proyectoId) => {
  try {
    const response = await api.post(`/notificaciones/limpiar-historial/${proyectoId}`);
    return response.data;
  } catch (error) {
    console.error('Error al limpiar historial:', error);
    throw error;
  }
};

/**
 * Probar envío de notificaciones (para testing)
 */
export const probarEnvio = async () => {
  try {
    const response = await api.post('/notificaciones/probar-envio');
    return response.data;
  } catch (error) {
    console.error('Error al probar envío:', error);
    throw error;
  }
};

/**
 * Enviar solicitud de proceso por correo
 */
export const enviarSolicitudProceso = async (datos) => {
  try {
    const response = await api.post('/notificaciones/enviar-solicitud-proceso', datos);
    return response.data;
  } catch (error) {
    console.error('Error al enviar solicitud de proceso:', error);
    throw error;
  }
};

/**
 * Enviar correo de Ruta Crítica Recepción (notificación manual)
 */
export const obtenerTodasConfiguraciones = async () => {
  try {
    const response = await api.get('/notificaciones/todos');
    return response.data.configuraciones;
  } catch (error) {
    console.error('Error al obtener todas las configuraciones:', error);
    throw error;
  }
};

/**
 * Envía una notificación de prueba (Ruta Crítica + Resumen Gerencial) a todos
 * los destinatarios y gerentes habilitados, marcada como [PRUEBA] en el asunto.
 */
export const probarTodasLasNotificaciones = async () => {
  try {
    const response = await api.post('/notificaciones/probar-todo');
    return response.data;
  } catch (error) {
    console.error('Error al probar todas las notificaciones:', error);
    throw error.response?.data || { error: 'Error al probar notificaciones' };
  }
};

export const enviarCorreoRecepcion = async (datos) => {
  try {
    const response = await api.post('/notificaciones/enviar-correo-recepcion', datos);
    return response.data;
  } catch (error) {
    console.error('Error al enviar correo Recepción:', error);
    throw error;
  }
};

const notificacionesService = {
  obtenerConfiguracion,
  guardarConfiguracion,
  limpiarHistorial,
  probarEnvio,
  probarTodasLasNotificaciones,
  enviarSolicitudProceso,
  enviarCorreoRecepcion,
  obtenerTodasConfiguraciones
};

export default notificacionesService;
